import { AutoPropertiesDTO } from "./AutoProperties";
import { ConditionSide, InsoleType } from "./Insole";

export class PatientConsditions{
    insoleTemplateRight: InsoleType = InsoleType.Standard;
    insoleTemplateLeft: InsoleType = InsoleType.Standard;
    metatarsalgia: ConditionSide = ConditionSide.none;
    halluxLimitus: ConditionSide = ConditionSide.none;
    sesamoiditis:  ConditionSide = ConditionSide.none;
    heelSpur: ConditionSide = ConditionSide.none;
    diabetic: ConditionSide = ConditionSide.none;
    archIndexLeft: number = -1;
    archIndexRight: number = -1;
    
    constructor(init?: Partial<PatientConsditions>) {
        if (init) Object.assign(this, init);
    }

    loadFromDTO(dto: AutoPropertiesDTO) {
        this.insoleTemplateRight = dto.insoleTemplateRight;
        this.insoleTemplateLeft = dto.insoleTemplateLeft;
        this.metatarsalgia = dto.metatarsalgia!;
        this.halluxLimitus = dto.halluxLimitus!;
        this.sesamoiditis = dto.sesamoiditis!;
        this.heelSpur = dto.heelSpur!;
        this.diabetic = dto.diabetic!;
        this.archIndexLeft = dto.archIndexLeft;
        this.archIndexRight = dto.archIndexRight;
    }
    toJson () {
        return{
            insoleTemplateRight: this.insoleTemplateRight,
            insoleTemplateLeft: this.insoleTemplateLeft,
            archIndexRight: this.archIndexRight,
            archIndexLeft: this.archIndexLeft,
            metatarsalgia: this.metatarsalgia,
            halluxLimitus: this.halluxLimitus,
            sesamoiditis: this.sesamoiditis,
            heelSpur: this.heelSpur,
            diabetic: this.diabetic
        }
    }
}